import styled from 'styled-components';

export const FloatingLink = styled.a`
  position: fixed;
  right: 24px;
  bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  color: #ffffff;
  box-shadow: 0 16px 30px rgba(18, 140, 126, 0.35);
  z-index: 1100;
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;

  svg {
    transition: transform 180ms ease;
  }

  &:hover {
    transform: translateY(-3px) scale(1.04);
    box-shadow: 0 20px 36px rgba(18, 140, 126, 0.45);
    filter: brightness(1.05);

    svg {
      transform: scale(1.06);
    }
  }

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.primary};
    outline-offset: 4px;
  }

  @media (max-width: 768px) {
    right: 16px;
    bottom: 16px;
    width: 52px;
    height: 52px;

    svg {
      width: 26px;
      height: 26px;
    }
  }
`;
